<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-16 16:59:51
 * @LastEditTime: 2019-09-19 11:23:59
 * @LastEditors: Please set LastEditors
 -->
<template>
<div id="page_Container">
    <div id="main-container" class="main-container">
        <div id="withdrawalRequest">

            <div class="header">
                <van-panel title="提现金额" desc="51.07">
                    <div slot="header">
                        <div class="title">提现金额</div>
                        <div class="input-amount">
                            <van-field v-model="bankParams.amount" placeholder="请输入提现金额" class="backName" label="￥" type="number" label-width="10"/>
                        </div>

                    </div>
                    <div class="unimportance">可提现余额：¥{{allowedwithdrawalCash?allowedwithdrawalCash.toFixed(2): '0.00'}}</div>
                </van-panel>
            </div>
            <!-- <div class="bankCard">
                <div class="bank-content">
                    <van-field v-model="bankParams.withdrawalBankName" placeholder="开户行名称" class="backName" />
                    <van-field v-model="bankParams.withdrawalBankNo" placeholder="请输入银行卡号" class="backNo" type="number"/>
                    招商银行      62208394848734073094702
                </div>
            </div> -->
            <van-cell-group class="submit-from">
                <van-field v-model="bankParams.withdrawalBankName" label="开户行" placeholder="请输入开户行名称" />
                <van-field v-model="bankParams.withdrawalBankNo" label="银行卡号" placeholder="请输入银行卡号" type="number"/>
                <van-field
                    v-model="mobileNumber"
                    center
                    clearable
                    label="注册手机"
                    placeholder="请输入手机号"
                    disabled
                >
                    <van-button slot="button" size="small" class="send-btn"  v-bind:class="{sended:!codeButton}" type="primary" id="btn" @click="handleCode"  :disabled="!codeButton">{{codeMsg}}</van-button>
                </van-field>
                <van-field v-model="bankParams.validateCode" label="验证码" placeholder="请输入短信验证码"/>
            </van-cell-group>
            <div class="info">
                <div>规则：</div>
                <div>1 最少{{withdrawalCashLimit}}元起才能发起提现</div>
            </div>
            <div class="submitBtn">
                <van-button size="normal" type="primary" round @click="handleSubmit" :disabled="submitDisabled">提交</van-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import {
    mapGetters
} from 'vuex';
export default {
    data() {
        return {
            bankParams: {
                withdrawalBankName: '',
                withdrawalBankNo: '',
                mobileNumber: '',
                validateCode: '',
                amount: ''
            },
            bankArr: [
                'withdrawalBankName',
                'withdrawalBankNo',
                'mobileNumber',
                'validateCode',
                'amount'
            ],
            submitDisabled: false,
            withdrawalCashLimit: '',
            allowedwithdrawalCash: '',
            codeButton: true, // 发送验证码按钮 是否禁用
            codeMsg: '获取验证码',
            codeTime: 60
        };
    },
    esvReady() {},
    esvShow() {
        this.queryAccountWithdrawalCashRecord();
        this.queryMemberAccountDetail();
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ]),
        mobileNumber() {
            if (this.bankParams.mobileNumber) {
                return this.bankParams.mobileNumber.replace(/^(.{4})(?:\d+)(.{4})$/, '$1******$2');
            }
            return '';
        }
    },
    methods: {
        timeCount() {
            var ths = this;
            ths.codeButton = false;
            ths.codeTime--;
            ths.codeMsg = ths.codeTime + 's后重新发送';
            ths.timeDao = setInterval(function() {
                if (ths.codeTime < 1) {
                    ths.codeButton = true;
                    ths.codeMsg = '重新发送';
                    clearInterval(ths.timeDao);
                    ths.codeTime = 60;
                } else {
                    ths.codeTime--;
                    ths.codeMsg = ths.codeTime + 's后重新发送';
                }
            }, 1000);
        },
        handleSubmit() {
            const ths = this;
            // debugger;
            if ((ths.bankParams.amount ? ths.bankParams.amount : 0) < ths.withdrawalCashLimit) {
                ths.$toast('至少提现' + ths.withdrawalCashLimit + '元');
                return false;
            } else if ((ths.bankParams.amount ? ths.bankParams.amount : 0) > ths.allowedwithdrawalCash) {
                ths.$toast('提现金额超出可提余额');
                return false;
            } else if (!ths.bankParams.withdrawalBankName || ths.bankParams.withdrawalBankName.length <= 0) {
                ths.$toast('开户行名称不能为空');
                return false;
            } else if (!ths.bankParams.withdrawalBankNo || !(/^[0-9]{16,19}$/.test(ths.bankParams.withdrawalBankNo))) {
                ths.$toast('请输入正确的银行卡号');
                return false;
            } else if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(ths.bankParams.mobileNumber))) {
                if (ths.bankParams.mobileNumber.length === 0) {
                    ths.$toast('请填写手机号码');
                } else {
                    ths.$toast('请输入正确的手机号码');
                }
                return false;
            } else if (!ths.bankParams.validateCode || ths.bankParams.validateCode.length <= 0) {
                ths.$toast('请填写验证码');
                return false;
            } else if (ths.bankParams.validateCode.length < 4) {
                ths.$toast('请填写正确的验证码');
                return false;
            }

            this.$doRequest(
                {
                    url: '/account/applyWithdrawalCash',
                    params: ths.bankParams,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }

                },
                function(data) {
                    ths.esvBackPage(1);
                }
            );
        },
        queryMemberAccountDetail() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryMemberAccountDetail',
                    params: {
                        merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    ths.bankParams.mobileNumber = data.result.mobileNumber;
                }
            );
        },
        queryAccountWithdrawalCashRecord() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryAccountWithdrawalCashRecord',
                    params: { merchantInfo: JSON.stringify(this.merchantInfoSwitch) },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    data = data.result;
                    ths.bankParams.withdrawalBankName = data.withdrawalBankName;
                    ths.bankParams.withdrawalBankNo = data.withdrawalBankNo;
                    ths.withdrawalCashLimit = data.withdrawalCashLimit;
                    ths.allowedwithdrawalCash = data.allowedwithdrawalCash;
                }
            );
        },
        // 发送验证码
        handleCode() {
            const ths = this;
            const mobileNumber = this.bankParams.mobileNumber;
            if ((/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobileNumber))) {
                ths.$doRequest({
                    url: '/user/smsSend',
                    params: {
                        mobileNumber: this.bankParams.mobileNumber.trim()
                    },
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        ths.codeButton = true;
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        ths.$toast('短信验证码发送成功');
                        ths.timeCount();
                    } else {
                        ths.$toast(data.message);
                    }
                });
            } else {
                ths.codeButton = true;
                if (mobileNumber.length === 0) {
                    ths.$toast('请填写手机号码');
                } else {
                    ths.$toast('请输入正确的手机号码');
                }
            }
        }
    }
};
</script>

<style lang="scss">
#withdrawalRequest {
    .header {
        .title {
            padding: 12px;
            font-size: 14px;
        }
        .input-amount {
            .van-cell {
                line-height: 1.5;
            }
            .van-cell__value {
                font-size: 40px;
            }
            .van-cell__title {
                position: relative !important;
                width: 20px !important;
                overflow: initial;
                span {
                    font-weight: 700;
                    position: absolute !important;
                    bottom: -20px !important;
                }
            }
        }
        .unimportance {
            font-size: 12px;
            color: #999;
            padding: 12px;
        }
    }
    .bankCard {
        display: flex;
        justify-content: center;
        padding: 12px;
        height: 64px;
        .bank-content {
            width: 100%;
            background-color: #f9f9f9;
            border-radius: 10px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: #414141;
            display: flex;
            overflow: hidden;

            .backName {
                flex: 1;
                border-right: 2px solid #f2f2f2;
            }
            .backNo {
                flex: 3;
            }
        }
    }
    .submit-from {
        margin-top: 10px;
        margin-bottom: 10px;
        .van-cell .van-cell__title {
            width: 90px !important;
            color: #BEBEC5;
        }
    }
    .info {
        padding: 0 12px;
        color: #999;
    }
    .send-btn {
                border: none;
                border-radius: 0;
                background: white;
                color: $primary-color;
                font-size: 14px;
            }
            .sended{
                color: #999;
            }
    .submitBtn {
        height: 44px;
        padding: 24px;
        .van-button {
            width: 100%;
        }
    }
}
</style>
